<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    class="icon"
    viewBox="0 0 24 24"
  >
    <path
      d="M7.81462 3.0402H15.6629L20.3199 7.7934V18.3566H7.81462V3.0402ZM9.48198 4.7421V16.6548H18.6525V9.8475H13.8504V4.7421H9.48198ZM15.5178 5.0943V8.1457H18.7074L15.5178 5.0943ZM6.14726 6.4439V20.0584H15.5178V21.7602H4.4799V6.4439H6.14726Z"
    />
  </svg>
</template>

<script>
export default {
  name: 'IconCopy',
};
</script>

<style scoped>
.icon {
  display: inline-block;
  width: 1.5em;
  height: 1.5em;
  fill: inherit;
  flex-shrink: 0;
}
</style>